export default __webpack_public_path__ + "df6521c028eda4c6cd3a33cfb5b493dc.svg";